// src/components/auth/PublicRoute.jsx

import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { LoadingSpinner } from '@/components/common/LoadingSpinner';
import { ROUTES } from '@/routes/AppRouter';

/**
 * Bloqueia rotas de autenticação para usuários já logados.
 *
 * Fluxo:
 *  1. isLoading → exibe spinner (aguarda sessão resolver antes de qualquer decisão)
 *  2. Autenticado → redireciona para /dashboard
 *  3. Não autenticado → renderiza children (página de login/registro/etc.)
 */
const PublicRoute = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();

  // Aguarda a resolução da sessão — nunca redireciona aqui
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  // Já autenticado: não deixa acessar /login, /register, etc.
  if (isAuthenticated) {
    return <Navigate to={ROUTES.DASHBOARD} replace />;
  }

  return children;
};

export default PublicRoute;
